import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
// import Home from './pages/Home'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.js'
// import Layout from './components/Layout'
import UserAggreement from './pages/UserAggreement'
import Privacy from './pages/Privacy'
import FairPlay from './pages/FairPlay'
import Community from './pages/Community'
import Notice from './pages/Notice'
import SubscriberAgreement from './pages/SubscriberAgreement'

const App = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          {/* <Route path="/" element={<Layout />}>
            <Route index path="" element={<Home />} />
          </Route> */}
          <Route path="user-agreement" element={<UserAggreement />} />
          <Route path="privacy-policy" element={<Privacy />} />
          <Route path="fair-play-policy" element={<FairPlay />} />
          <Route path="community-policy" element={<Community />} />
          <Route path="notice-and-disclaimer" element={<Notice />} />
          <Route path="subscriber-agreement" element={<SubscriberAgreement />} />
        </Routes>
      </div>
    </BrowserRouter>
  )
}

export default App
